import {
  Avatar,
  Button,
  FormControl,
  IconButton,
  Input,
  InputAdornment,
  MenuItem,
  Rating,
  TextField,
} from "@mui/material";
import moment from "moment";
import React, { useEffect, useState } from "react";
import {
  useLocation,
  useNavigate,
  useOutletContext,
  useParams,
} from "react-router-dom";
import Compressor from "compressorjs";
import Constants from "../../../data/Constants";
import {
  getSingleMentor,
  createSingleMentor,
  updateSingleMentor,
  getMentorsList,
} from "../../../services/mentor.service";
import Utils from "../../../utils";
import {
  createSingleCourse,
  getCourseReviews,
  getCoursesList,
  getSingleCourse,
  updateSingleCourse,
} from "../../../services/course.service";
import MediaManager from "../../../components/MediaManager";
import useMediaManager from "../../../hooks/useMediaManager";
import MediaCard from "../../../components/MediaCard";
import EditableSelect from "../../../components/EditableSelect";
import { getCurriculumNameList } from "../../../services/curriculum.service";
import SingleFaq from "../../../components/SingleFaq";
import SingleReview from "../../../components/SingleReview";
import {
  DatePicker,
  DateTimePicker,
  LocalizationProvider,
} from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { MdDelete } from "react-icons/md";
import { AiOutlinePlus } from "react-icons/ai";
import SubscriptionDialog from "components/SubscriptionDialog";
import { getIn, useFormik } from "formik";
import * as yup from "yup";
import { BsCheck } from "react-icons/bs";

const defaultCourse = {
  name: "",
  groupCourseId: "",
  otherTypes: [],
  shortDescription: "",
  costPrice: "",
  studentCount: 1,
  salePrice: "",
  duration: "",
  grade: "",
  maxGrade: "",
  type: "",
  status: "",
  averageRating: 0,
  languages: [],
  mentors: [],
  carousal: [],
  tags: [],
  subscriptionPlans: [],
  courseDetails: {
    description: "",
    curriculum: "",
    faq: [],
    reviews: [],
  },
};

function EditCourse(props) {
  const [updateView, forceUpdateView] = useState(0);
  const [subscription, setSubscription] = useState();
  const { id } = useParams();
  const [mediaManager, setMediaManager] = useMediaManager();
  var savedCourse;

  if (id) {
    savedCourse = defaultCourse;
  } else {
    savedCourse =
      JSON.parse(localStorage.getItem("draftCourse")) ?? defaultCourse;
  }

  const [data, setData] = useState(savedCourse);
  const [courses, setCourses] = useState([]);
  const [reviews, setReviews] = useState([]);
  const [mentors, setMentors] = useState([]);
  const [curriculum, setCurriculum] = useState([]);
  const navigate = useNavigate();

  const { setProgress, setToast, isRefreshed, runCanfetti } =
    useOutletContext();

  const validationSchema = yup.object({
    name: yup.string().required().label("Course  Name").max(100),

    shortDescription: yup
      .string()
      .required()
      .label("Short Description")
      .min(10)
      .max(250),

    costPrice: yup.number().positive().required().label("Cost Price"),

    studentCount: yup
      .number()
      .positive()
      .min(1)
      .required()
      .label("Student Count"),

    salePrice: yup
      .number()
      .required()
      .label("Sale Price")
      .when(["costPrice", "type"], (costPrice, type) => {
        return yup
          .number()
          .required()
          .label("Sale Price")
          .min(0)
          .max(
            costPrice,
            "Sale Price should be less than or equal to Cost Price"
          );
      }),

    grade: yup
      .number()
      .required()
      .label("Min Grade")
      .min(Constants.Grade.MIN)
      .max(Constants.Grade.MAX),

    maxGrade: yup.number().when(["grade"], (grade) => {
      return yup
        .number()
        .nullable()
        .label("Max Grade")
        .typeError("Grade must be a number")
        .moreThan(grade, "Grade should be greater than Minimum Grade")
        .max(Constants.Grade.MAX)
        .notRequired();
    }),

    cover: yup.object().required().label("Cover"),

    type: yup
      .string()
      .required()
      .label("Course Type")
      .oneOf(Constants.Course.Types),

    status: yup
      .string()
      .required()
      .label("Course Status")
      .oneOf(Constants.Course.Status),

    // upcomingDate: yup.string().required(),

    courseDetails: yup.object().shape({
      description: yup
        .string()
        .required()
        .label("Long Description")
        .min(25)
        .max(4000),

      curriculum: yup
        .string("Enter the Long Description")
        .required("Long Description is required")
        .label("Curriculum"),
    }),
  });

  const formik = useFormik({
    initialValues: data,
    validationSchema: validationSchema,
    onSubmit: (values) => {
      formSubmitHandler(values);
    },
  });

  const formSubmitHandler = async (values) => {
    values.customReviews = reviews;

    try {
      setProgress(true);
      const res = id
        ? await updateSingleCourse(id, values)
        : await createSingleCourse(values);

      setProgress(false);

      if (id) {
        setToast({
          success: true,
          message: Constants.Actions.Updated.Success("Course"),
        });

        formik.values = {
          name: "",
          groupCourseId: "",
          otherTypes: [],
          shortDescription: "",
          costPrice: "",
          studentCount: 1,
          salePrice: "",
          duration: "",
          grade: "",
          maxGrade: "",
          type: "",
          status: "",
          averageRating: 0,
          languages: [],
          mentors: [],
          carousal: [],
          tags: [],
          subscriptionPlans: [],
          courseDetails: {
            description: "",
            curriculum: "",
            faq: [],
            reviews: [],
          },
        };
        navigate("/dashboard/courses");
      } else {
        if (res) {
          localStorage.removeItem("draftCourse");
          // navigate("/dashboard/courses/edit/" + res._id);
          setToast({
            success: true,
            message: Constants.Actions.Created.Success("Course"),
          });


          runCanfetti();
          formik.values = {
            name: "",
            groupCourseId: "",
            otherTypes: [],
            shortDescription: "",
            costPrice: "",
            studentCount: 1,
            salePrice: "",
            duration: "",
            grade: "",
            maxGrade: "",
            type: "",
            status: "",
            averageRating: 0,
            languages: [],
            mentors: [],
            carousal: [],
            tags: [],
            subscriptionPlans: [],
            courseDetails: {
              description: "",
              curriculum: "",
              faq: [],
              reviews: [],
            },
          };
          navigate("/dashboard/courses");
        }
      }
    } catch (error) {
      setProgress(false);
      setToast({ error: true, message: Utils.CustomErrorMessage(error) });
    }
  };

  const discardHandler = () => {
    if (id) {
      forceUpdateView(1);
    } else {
      formik.resetForm({ values: defaultCourse });
    }
  };

  useEffect(() => {
    async function mentorApi() {
      try {
        setProgress(true);

        const res = await getMentorsList();

        if (res) {
          setMentors(res);
        } else {
          // error
          setToast({ error: true, message: Constants.Error.UNKNOWN });
        }

        setProgress(false);
      } catch (error) {
        // error

        console.log(error);
        setProgress(false);
        setToast({ error: true, message: Utils.CustomErrorMessage(error) });
      }
    }

    async function curriculumApi() {
      try {
        setProgress(true);

        const res = await getCurriculumNameList();

        if (res) {
          setCurriculum(res);
        } else {
          // error
          setToast({ error: true, message: Constants.Error.UNKNOWN });
        }

        setProgress(false);
      } catch (error) {
        // error

        console.log(error);
        setProgress(false);
        setToast({ error: true, message: Utils.CustomErrorMessage(error) });
      }
    }

    async function reviewApi() {
      if (id) {
        try {
          const res = await getCourseReviews(id);

          if (res) {
            setReviews(res);
          } else {
            // error
            setToast({ error: true, message: Constants.Error.UNKNOWN });
          }
        } catch (error) {
          // error

          console.log(error);
          setToast({ error: true, message: Utils.CustomErrorMessage(error) });
        }
      }
    }

    async function loadCourses() {
      try {
        const filters = {
          status: "Published",
          sortByGroup: true,
        };
        setProgress(true);
        const data = await getCoursesList(filters);
        if (data) {
          setCourses(data);
          setProgress(false);
        } else {
          // error
          setProgress(false);
          setToast({ error: true, message: Constants.Error.FETCH });
        }
      } catch (error) {
        // error
        setProgress(false);
        setToast({ error: true, message: Utils.CustomErrorMessage(error) });
      }
    }

    async function api() {
      if (id) {
        try {
          setProgress(true);

          const res = await getSingleCourse(id);
          if (res) {
            res.courseDetails.curriculum = res.courseDetails.curriculum._id; // set id instead of whole object. Reusing public API
            setData(res);
            formik.setValues(res);
          } else {
            // error
            setToast({ error: true, message: Constants.Error.UNKNOWN });
          }

          setProgress(false);
        } catch (error) {
          // error

          console.log(error);
          setProgress(false);
          setToast({ error: true, message: Utils.CustomErrorMessage(error) });
        }
      }
    }

    curriculumApi();
    api();
    mentorApi();
    loadCourses();

    if (id) {
      reviewApi();
    }
  }, [updateView, isRefreshed]);

  useEffect(() => {
    if (!id) {
      localStorage.setItem("draftCourse", JSON.stringify(formik.values));
    }
  }, [formik.values]);

  return (
    <React.Fragment>
      {data && (
        <form onSubmit={formik.handleSubmit}>
          <div className="grid grid-cols-2">
            <div>
              <h1 className="p-4 font-extrabold text-lg">Basic Details</h1>
              <div className=" p-5 grid-cols-2 grid gap-5">
                <TextField
                  label="Course Name"
                  variant="filled"
                  size="small"
                  name="name"
                  value={formik.values.name}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={formik.touched.name && Boolean(formik.errors.name)}
                  helperText={formik.touched.name && formik.errors.name}
                  required
                  className="col-span-2"
                />
                <TextField
                  label="Short Description"
                  variant="filled"
                  size="small"
                  value={formik.values.shortDescription}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={
                    formik.touched.shortDescription &&
                    Boolean(formik.errors.shortDescription)
                  }
                  helperText={
                    formik.touched.shortDescription &&
                    formik.errors.shortDescription
                  }
                  className="col-span-2"
                  name="shortDescription"
                />
                <TextField
                  label="Cost Price"
                  variant="filled"
                  type="number"
                  size="small"
                  value={formik.values.costPrice}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={
                    formik.touched.costPrice && Boolean(formik.errors.costPrice)
                  }
                  helperText={
                    formik.touched.costPrice && formik.errors.costPrice
                  }
                  required
                  name="costPrice"
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="start">
                        {Constants.CURRENCY_SYMBOL}
                      </InputAdornment>
                    ),
                  }}
                />
                <div>
                  <TextField
                    label="Sale Price"
                    type="number"
                    variant="filled"
                    size="small"
                    fullWidth
                    value={formik.values.salePrice}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={
                      formik.touched.salePrice &&
                      Boolean(formik.errors.salePrice)
                    }
                    helperText={
                      formik.touched.salePrice && formik.errors.salePrice
                    }
                    required
                    name="salePrice"
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="start">
                          {Constants.CURRENCY_SYMBOL}
                        </InputAdornment>
                      ),
                    }}
                  />
                  {formik.values.salePrice == 0 && (
                    <div className="text-xsm text-green-600 font-bold flex items-center">
                      <BsCheck size={16} />
                      Free Course
                    </div>
                  )}
                </div>

                <TextField
                  label="Min Grade"
                  variant="filled"
                  type="number"
                  size="small"
                  value={formik.values.grade}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={formik.touched.grade && Boolean(formik.errors.grade)}
                  helperText={formik.touched.grade && formik.errors.grade}
                  required
                  name="grade"
                />

                <TextField
                  type="number"
                  label="Max Grade"
                  variant="filled"
                  size="small"
                  name="maxGrade"
                  value={formik.values.maxGrade}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={
                    formik.touched.maxGrade && Boolean(formik.errors.maxGrade)
                  }
                  helperText={formik.touched.maxGrade && formik.errors.maxGrade}
                />

                <TextField
                  label="Languages"
                  variant="filled"
                  size="small"
                  value={formik.values.languages}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={
                    formik.touched.languages && Boolean(formik.errors.languages)
                  }
                  helperText={
                    formik.touched.languages && formik.errors.languages
                  }
                  name="languages"
                />

                <TextField
                  label="Type"
                  variant="filled"
                  size="small"
                  name="type"
                  value={formik.values.type}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={formik.touched.type && Boolean(formik.errors.type)}
                  helperText={formik.touched.type && formik.errors.type}
                  required
                  select
                >
                  {Constants.Course.Types.map((option, index) => {
                    return (
                      <MenuItem key={index} value={option}>
                        {option}
                      </MenuItem>
                    );
                  })}
                </TextField>
                <TextField
                  label="Status"
                  variant="filled"
                  size="small"
                  value={formik.values.status}
                  name="status"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={formik.touched.status && Boolean(formik.errors.status)}
                  helperText={formik.touched.status && formik.errors.status}
                  required
                  select
                >
                  {Constants.Course.Status.map((option, index) => {
                    return (
                      <MenuItem key={index} value={option}>
                        {option}
                      </MenuItem>
                    );
                  })}
                </TextField>

                <TextField
                  label="Student Count"
                  variant="filled"
                  type="number"
                  size="small"
                  value={formik.values.studentCount}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={
                    formik.touched.studentCount &&
                    Boolean(formik.errors.studentCount)
                  }
                  helperText={
                    formik.touched.studentCount && formik.errors.studentCount
                  }
                  required
                  name="studentCount"
                />

                {formik.values.status == "Upcoming" && (
                  <LocalizationProvider dateAdapter={AdapterMoment}>
                    <DatePicker
                      label="Upcoming Date"
                      name="upcomingDate"
                      disablePast
                      className="col-span-2"
                      value={formik.values.upcomingDate}
                      onBlur={formik.handleBlur}
                      onChange={(m) => {
                        if (m) {
                          formik.setFieldValue("upcomingDate", m.format());
                        } else {
                          formik.setFieldError(
                            "upcomingDate",
                            "Upcoming Field is required"
                          );
                        }
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          required
                          fullWidth
                          error={
                            formik.touched.upcomingDate &&
                            Boolean(formik.errors.upcomingDate)
                          }
                          helperText={
                            formik.touched.upcomingDate &&
                            formik.errors.upcomingDate
                          }
                        />
                      )}
                    />
                  </LocalizationProvider>
                )}
                {/*  If Course is Subscription Type  */}
                {formik.values.type == "Subscription" && (
                  <React.Fragment>
                    <div className="col-span-2 flex">
                      {formik.values.subscriptionPlans.map((sp, index) => {
                        return (
                          <div className="p-4 bg-secondary m-2 rounded-lg cursor-pointer shadow-md active:bg-secondaryDark active:scale-105 relative">
                            <div onClick={() => setSubscription(sp)}>
                              <div className="font-bold">
                                {sp.friendlyTime ?? "New"}
                              </div>
                              <div className="">
                                {sp.friendlyTime
                                  ? Constants.CURRENCY_SYMBOL + sp.salePrice
                                  : ""}
                              </div>
                            </div>
                            <div className="absolute right-0 bottom-0 translate-x-3 translate-y-3 bg-gray-800  rounded-full z-100">
                              <IconButton
                                onClick={(e) => {
                                  const temp = [
                                    ...formik.values.subscriptionPlans,
                                  ];
                                  temp.splice(index, 1);
                                  formik.setFieldValue(
                                    "subscriptionPlans",
                                    temp
                                  );
                                }}
                              >
                                <MdDelete size={16} color="white" />
                              </IconButton>
                            </div>
                          </div>
                        );
                      })}

                      <div
                        className="p-4 bg-secondary m-2 rounded-lg cursor-pointer shadow-md flex items-center w-24 justify-center active:bg-secondaryDark"
                        onClick={() => {
                          const temp = [...formik.values.subscriptionPlans];

                          const defaultSubscription = {
                            _id: "T" + Utils.uniqueId(),
                            _new: true,
                            days: "",
                            costPrice: "",
                            salePrice: "",
                          };

                          // temp.push(defaultSubscription);
                          // formik.setFieldValue("subscriptionPlans", temp);
                          setSubscription(defaultSubscription);
                        }}
                      >
                        <AiOutlinePlus size={24} />
                      </div>

                      {subscription && (
                        <SubscriptionDialog
                          subscription={subscription}
                          onClose={() => {
                            setSubscription(undefined);
                          }}
                          onChange={(s) => {
                            if (s._new) {
                              // create new
                              const temp = [...formik.values.subscriptionPlans];
                              temp.push(s);
                              formik.setFieldValue("subscriptionPlans", temp);
                              return;
                            }
                            // update
                            const index =
                              formik.values.subscriptionPlans.findIndex(
                                (val) => {
                                  return val._id == s._id;
                                }
                              );
                            const temp = [...formik.values.subscriptionPlans];
                            temp[index] = s;
                            formik.setFieldValue("subscriptionPlans", temp);
                          }}
                        />
                      )}
                    </div>
                  </React.Fragment>
                )}
                <TextField
                  label="Tags"
                  variant="filled"
                  size="small"
                  value={formik.values.tags}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={formik.touched.tags && Boolean(formik.errors.tags)}
                  helperText={formik.touched.tags && formik.errors.tags}
                  name="tags"
                  className="col-span-2"
                  minRows={3}
                  placeholder="Seperate every tag with a comma"
                  multiline
                />
                <div className={"flex flex-col gap-3 "}>
                  <div className="font-bold">Course Cover Photo* </div>
                  <span
                    className="text-xsm text-red-600"
                    hidden={
                      !formik.touched.cover && Boolean(formik.values.cover)
                    }
                  >
                    {formik.errors.cover}
                  </span>
                  <Button
                    variant="outlined"
                    onClick={() => {
                      setMediaManager({
                        open: true,
                        type: "Photo",
                        onSelect: (media) => {
                          const carousal = [...formik.values.carousal];
                          carousal[0] = media;
                          formik.setFieldValue("cover", media);
                          formik.setFieldValue("carousal", carousal);
                        },
                      });
                    }}
                  >
                    <span className="font-bold">Choose Image</span>
                  </Button>

                  {formik.values.cover && (
                    <MediaCard
                      media={formik.values.cover}
                      onClose={() => {
                        formik.setFieldValue("cover", "");
                      }}
                    />
                  )}
                </div>
                <div className={"flex flex-col gap-3 "}>
                  <div className="font-bold">Average Rating</div>
                  <Rating
                    value={formik.values.averageRating}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={
                      formik.touched.averageRating &&
                      Boolean(formik.errors.averageRating)
                    }
                    helperText={
                      formik.touched.averageRating &&
                      formik.errors.averageRating
                    }
                    required
                    name="averageRating"
                    size="large"
                    precision="0.1"
                  />
                </div>
              </div>
              <h1 className="p-4 font-extrabold text-lg">Reviews</h1>
              <div className=" p-5 grid gap-5">
                {/*  review has seperate state */}
                {reviews.map((review, index) => {
                  return (
                    <SingleReview
                      rating={review.rating}
                      message={review.message}
                      fullname={review.fullname}
                      key={index}
                      onChange={(r) => {
                        var temp = [...reviews];
                        temp[index] = { ...temp[index], ...r };
                        setReviews(temp);
                      }}
                      onDelete={() => {
                        const temp = [...reviews];
                        temp.splice(index, 1);
                        setReviews(temp);
                      }}
                    />
                  );
                })}
                <div className="text-right">
                  <Button
                    onClick={() => {
                      const temp = [...reviews];
                      temp.push({
                        rating: 0,
                        message: "",
                        fullname: "",
                        _new: true,
                      });
                      setReviews(temp);
                    }}
                  >
                    NEw Review +
                  </Button>
                </div>
              </div>
            </div>
            <div className=" border-primary  rounded-lg">
              <h1 className="p-4 font-extrabold text-lg">Course Details</h1>
              <div className=" p-5 grid-cols-2 grid gap-5">
                <TextField
                  label="Long Description"
                  variant="filled"
                  size="small"
                  multiline
                  minRows={3}
                  className="col-span-2"
                  value={formik.values.courseDetails.description}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={
                    getIn(formik.touched, "courseDetails.description") &&
                    Boolean(getIn(formik.errors, "courseDetails.description"))
                  }
                  helperText={
                    getIn(formik.touched, "courseDetails.description") &&
                    getIn(formik.errors, "courseDetails.description")
                  }
                  required
                  name="courseDetails.description"
                />
              </div>
              <h1 className="p-4 font-extrabold text-lg">Curriculum Data</h1>

              <div className="p-5">
                <TextField
                  label="Course Curriculum"
                  variant="filled"
                  size="small"
                  name="courseDetails.curriculum"
                  value={formik.values.courseDetails.curriculum}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={
                    getIn(formik.touched, "courseDetails.curriculum") &&
                    Boolean(getIn(formik.errors, "courseDetails.curriculum"))
                  }
                  helperText={
                    getIn(formik.touched, "courseDetails.curriculum") &&
                    getIn(formik.errors, "courseDetails.curriculum")
                  }
                  select
                  required
                  fullWidth
                >
                  {curriculum &&
                    curriculum.map((cr, index) => {
                      if (
                        formik.values.type == Constants.Course.Type.RECORDED
                      ) {
                        if (cr.type != Constants.Curriculum.Type.RECORDED) {
                          return;
                        }
                      } else if (
                        formik.values.type == Constants.Course.Type.LIVE_SINGLE
                      ) {
                        if (cr.type != Constants.Curriculum.Type.LIVE_SINGLE) {
                          return;
                        }
                      } else if (
                        formik.values.type == Constants.Course.Type.LIVE_GROUP
                      ) {
                        if (cr.type != Constants.Curriculum.Type.LIVE_GROUP) {
                          return;
                        }
                      } else if (
                        formik.values.type == Constants.Course.Type.SUBSCRIPTION
                      ) {
                        if (cr.type != Constants.Curriculum.Type.RECORDED) {
                          return;
                        }
                      }

                      return (
                        <MenuItem key={index} value={cr._id}>
                          {cr.name + " (" + cr._id.slice(0) + ")"}
                        </MenuItem>
                      );
                    })}
                </TextField>
              </div>

              {id &&
                formik.values.status != "Upcoming" &&
                formik.values.type != Constants.Course.Type.RECORDED &&
                formik.values.type != Constants.Course.Type.SUBSCRIPTION && (
                  <>
                    <h1 className="p-4 font-extrabold text-lg">Course Group</h1>

                    <div className="p-5">
                      <TextField
                        label="Course Group"
                        variant="filled"
                        size="small"
                        name="groupCourseId"
                        value={formik.values.groupCourseId}
                        defaultValue="none"
                        onChange={(e) => {
                          formik.setFieldValue(
                            "otherTypes",
                            courses
                              .filter(
                                (val) => val.groupCourseId == e.target.value
                              )
                              .map((val) => val._id)
                          );

                          formik.handleChange(e);
                        }}
                        onBlur={formik.handleBlur}
                        error={
                          formik.touched.groupCourseId &&
                          Boolean(formik.errors.groupCourseId)
                        }
                        helperText={
                          formik.touched.groupCourseId &&
                          formik.errors.groupCourseId
                        }
                        select
                        required
                        fullWidth
                      >
                        <MenuItem key={-1} value="none" defaultValue>
                          None
                        </MenuItem>

                        {courses &&
                          courses.map((cr, index) => {
                            if (cr._id == id) {
                              return;
                            }
                            return (
                              <MenuItem key={index} value={cr.groupCourseId}>
                                {cr.name + " (" + cr.groupCourseId + ")"}
                              </MenuItem>
                            );
                          })}
                      </TextField>
                      {courses && formik.values.otherTypes && (
                        <div className="my-4">
                          <h1 className="text-sm">Other Courses in Group:</h1>
                          <div className="my-2">
                            {formik.values.otherTypes.map((cid) => {
                              const cr = courses.find((val) => val._id == cid);

                              if (cr) {
                                return (
                                  <div className="bg-secondary p-2 rounded-md my-1">
                                    {cr.name}
                                  </div>
                                );
                              } else {
                                console.log("Shit ", cid);
                              }
                            })}
                          </div>
                        </div>
                      )}
                    </div>
                  </>
                )}

              <h1 className="p-4 font-extrabold text-lg">Course FAQ</h1>

              <div className=" p-5 grid gap-5">
                {formik.values.courseDetails.faq.map((faq, index) => {
                  return (
                    <SingleFaq
                      question={faq.question}
                      answer={faq.answer}
                      index={index}
                      key={index}
                      onChange={(sFaq) => {
                        const faq = [...formik.values.courseDetails.faq];
                        faq[index] = sFaq;
                        formik.setFieldValue("courseDetails.faq", faq);
                      }}
                      onDelete={() => {
                        const faq = [...formik.values.courseDetails.faq];
                        faq.splice(index, 1);
                        formik.setFieldValue("courseDetails.faq", faq);
                      }}
                    />
                  );
                })}
                <div className="text-right">
                  <Button
                    size="small"
                    onClick={() => {
                      const faq = [...formik.values.courseDetails.faq];
                      faq.push({ question: "", answer: "" });
                      formik.setFieldValue("courseDetails.faq", faq);
                    }}
                  >
                    NEw FAQ +
                  </Button>
                </div>
              </div>

              <h1 className="p-4 font-extrabold text-lg">Assigned Mentors</h1>
              <div className=" p-5 grid gap-5">
                <TextField
                  label="Choose Mentor"
                  variant="filled"
                  size="small"
                  fullWidth
                  value={"none"}
                  onChange={(e) => {
                    if (
                      formik.values.mentors.findIndex((m) => {
                        return m._id == e.target.value._id;
                      }) == -1
                    ) {
                      var tmp = [...formik.values.mentors];
                      tmp.push(e.target.value);
                      formik.setFieldValue("mentors", tmp);
                    }
                  }}
                  select
                  required
                >
                  <MenuItem key={-1} value="none">
                    Add a mentor
                  </MenuItem>
                  {mentors &&
                    mentors.map((mentor, index) => {
                      return (
                        <MenuItem key={index} value={mentor}>
                          {mentor.firstname +
                            " " +
                            mentor.lastname +
                            " (" +
                            mentor._id.slice(0) +
                            ")"}
                        </MenuItem>
                      );
                    })}
                </TextField>

                {formik.values.mentors.map((mentor, index) => {
                  return (
                    <div className="bg-secondary p-2 rounded-md flex items-center gap-2">
                      <Avatar
                        src={mentor.picture}
                        size="small"
                        className="m-2"
                      />
                      <div className="flex-grow">
                        {mentor.firstname +
                          " " +
                          mentor.lastname +
                          " (" +
                          mentor._id +
                          ")"}
                      </div>

                      <IconButton>
                        <MdDelete
                          className="cursor-pointer"
                          size={24}
                          onClick={() => {
                            const index = formik.values.mentors.findIndex(
                              (m) => {
                                return m._id == mentor._id;
                              }
                            );

                            if (index != -1) {
                              var tmp = [...formik.values.mentors];
                              tmp.splice(index, 1);
                              formik.setFieldValue("mentors", tmp);
                            }
                          }}
                        />
                      </IconButton>
                    </div>
                  );
                })}

                {formik.values.mentors?.length == 0 && "No Mentors Assigned"}
              </div>

              <h1 className="p-4 font-extrabold text-lg">Course Carousal</h1>
              <div className="p-5 flex gap-5 flex-wrap">
                {formik.values.carousal &&
                  formik.values.carousal.map((banner, index) => {
                    if (index == 0) {
                      return (
                        <MediaCard media={banner} key={index} size="small" />
                      );
                    }
                    return (
                      <MediaCard
                        media={banner}
                        key={index}
                        size="small"
                        onClose={() => {
                          const carousal = [...formik.values.carousal];
                          carousal.splice(index, 1);
                          formik.setFieldValue("carousal", carousal);
                        }}
                      />
                    );
                  })}

                <div
                  className="bg-primary font-bold text-white  h-32 w-52 flex items-center justify-center rounded cursor-pointer"
                  onClick={() => {
                    setMediaManager({
                      open: true,
                      onSelect: (media) => {
                        const carousal = [...formik.values.carousal];
                        carousal.push(media);
                        formik.setFieldValue("carousal", carousal);
                      },
                    });
                  }}
                >
                  <AiOutlinePlus size={100} color="white" />
                </div>
              </div>

              <div className="justify-end p-5 gap-5 flex">
                <Button type="reset" onClick={discardHandler}>
                  Discard Changes
                </Button>
                <Button
                  type="submit"
                  variant="contained"
                  onClick={formik.handleSubmit}
                >
                  {id ? "Update" : "Create"} Course
                </Button>
              </div>
              <div className="text-sm text-gray-700 text-right">
                Your changes are automatically saved in browser.
              </div>
            </div>
          </div>

          <MediaManager
            open={mediaManager.open}
            type={mediaManager.type}
            onClose={() => {
              setMediaManager({ ...mediaManager, open: false });
            }}
            onSelect={mediaManager.onSelect}
          />
        </form>
      )}
    </React.Fragment>
  );
}

export default EditCourse;
